import React from 'react'
// import { useSelector } from 'react-redux';
import storePersist from '../../../../../redux/storePersist';
// import { selectListItems } from '../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function TransactionLogsFilterComponent({ handleFormChange, selectedGateway, handleInnerFormChange, apply }: any) {
  const countries = storePersist.get('countries').current?.items;
  // const libraryData = useSelector(selectListItems)
  const types = [
    { Id: 1, "Name": "sellerApp", "value": "sellerApp" },
    { Id: 2, "Name": "buyerApp", "value": "buyerApp" },
  ]

  const actions = [
    { Id: 1, "Name": "search", "value": "search" },
    { Id: 2, "Name": "on_search", "value": "on_search" },

    { Id: 3, "Name": "select", "value": "select" },
    { Id: 4, "Name": "on_select", "value": "on_select" },

    { Id: 5, "Name": "init", "value": "init" },
    { Id: 6, "Name": "on_init", "value": "on_init" },

    { Id: 7, "Name": "confirm", "value": "confirm" },
    { Id: 8, "Name": "on_confirm", "value": "on_confirm" },

    { Id: 9, "Name": "status", "value": "status" },
    { Id: 10, "Name": "on_status", "value": "on_status" },

    { Id: 11, "Name": "track", "value": "track" },
    { Id: 12, "Name": "on_track", "value": "on_track" },

    { Id: 13, "Name": "cancel", "value": "cancel" },
    { Id: 14, "Name": "on_cancel", "value": "on_cancel" },

    { Id: 15, "Name": "update", "value": "update" },
    { Id: 16, "Name": "on_update", "value": "on_update" },

    { Id: 17, "Name": "rating", "value": "rating" },
    { Id: 18, "Name": "on_rating", "value": "on_rating" },

    { Id: 19, "Name": "support", "value": "support" },
    { Id: 20, "Name": "on_support", "value": "on_support" },

    { Id: 21, "Name": "issue", "value": "issue" },
    { Id: 22, "Name": "on_issue", "value": "on_issue" },

    { Id: 23, "Name": "issue_status", "value": "issue_status" },
    { Id: 24, "Name": "on_issue_status", "value": "on_issue_status" },   

    { Id: 25, "Name": "settle", "value": "settle" },
    { Id: 26, "Name": "on_settle", "value": "on_settle" }, 
    { Id: 27, "Name": "recon", "value": "recon" },
    { Id: 28, "Name": "on_recon", "value": "on_recon" }, 
    { Id: 29, "Name": "report", "value": "report" },
    { Id: 30, "Name": "on_report", "value": "on_report" },     

    { Id: 31, "Name": "info", "value": "info" },     
    { Id: 32, "Name": "on_info", "value": "on_info" },     


  ]
  const domains = [
    { Id: 1, "Name": "nic2004:60232", "value": "nic2004:60232" },
    { Id: 2, "Name": "ONDC:AGR10", "value": "ONDC:AGR10" },
    { Id: 3, "Name": "ONDC:AGR11", "value": "ONDC:AGR11" },

    { Id: 4, "Name": "ONDC:FIS10", "value": "ONDC:FIS10" },
    { Id: 5, "Name": "ONDC:FIS11", "value": "ONDC:FIS11" },
    { Id: 6, "Name": "ONDC:FIS12", "value": "ONDC:FIS12" },
    { Id: 7, "Name": "ONDC:FIS13", "value": "ONDC:FIS13" },
    { Id: 8, "Name": "ONDC:FIS14", "value": "ONDC:FIS14" },

    { Id: 9, "Name": "ONDC:LOG10", "value": "ONDC:LOG10" },
    { Id: 10, "Name": "ONDC:LOG11", "value": "ONDC:LOG11" },
    { Id: 11, "Name": "ONDC:LOG 12", "value": "ONDC:LOG 12" },
    { Id: 12, "Name": "ONDC:LOG 13", "value": "ONDC:LOG 13" },

    { Id: 13, "Name": "ONDC:MEC10", "value": "ONDC:MEC10" },
    { Id: 14, "Name": "ONDC:MEC11", "value": "ONDC:MEC11" },

    { Id: 15, "Name": "ONDC:NTS10", "value": "ONDC:NTS10" },
    { Id: 16, "Name": "ONDC:NTS11", "value": "ONDC:NTS11" },

    { Id: 17, "Name": "ONDC:ONEST10", "value": "ONDC:ONEST10" },
    { Id: 18, "Name": "ONDC:ONEST11", "value": "ONDC:ONEST11" },
    { Id: 19, "Name": "ONDC:ONEST12", "value": "ONDC:ONEST12" },
    { Id: 20, "Name": "ONDC:ONEST13", "value": "ONDC:ONEST13" },

    { Id: 21, "Name": "ONDC:RET10", "value": "ONDC:RET10" },
    { Id: 22, "Name": "ONDC:RET11", "value": "ONDC:RET11" },
    { Id: 23, "Name": "ONDC:RET12", "value": "ONDC:RET12" },
    { Id: 24, "Name": "ONDC:RET13", "value": "ONDC:RET13" },
    { Id: 25, "Name": "ONDC:RET14", "value": "ONDC:RET14" },
    { Id: 26, "Name": "ONDC:RET15", "value": "ONDC:RET15" },
    { Id: 27, "Name": "ONDC:RET16", "value": "ONDC:RET16" },
    { Id: 28, "Name": "ONDC:RET18", "value": "ONDC:RET18" },
    { Id: 29, "Name": "ONDC:RET1A", "value": "ONDC:RET1A" },
    { Id: 30, "Name": "ONDC:RET1B", "value": "ONDC:RET1B" },
    { Id: 31, "Name": "ONDC:RET1C", "value": "ONDC:RET1C" },
    { Id: 32, "Name": "ONDC:RET1D", "value": "ONDC:RET1D" },
    { Id: 33, "Name": "ONDC:RET1E", "value": "ONDC:RET1E" },

    { Id: 34, "Name": "ONDC:SRV10", "value": "ONDC:SRV10" },
    { Id: 35, "Name": "ONDC:SRV11", "value": "ONDC:SRV11" },
    { Id: 36, "Name": "ONDC:SRV12", "value": "ONDC:SRV12" },
    { Id: 37, "Name": "ONDC:SRV13", "value": "ONDC:SRV13" },
    { Id: 38, "Name": "ONDC:SRV14", "value": "ONDC:SRV14" },
    { Id: 39, "Name": "ONDC:SRV16", "value": "ONDC:SRV16" },
    { Id: 40, "Name": "ONDC:SRV17", "value": "ONDC:SRV17" },
    { Id: 41, "Name": "ONDC:SRV18", "value": "ONDC:SRV18" },

    { Id: 42, "Name": "ONDC:TRV10", "value": "ONDC:TRV10" },
    { Id: 43, "Name": "ONDC:TRV11", "value": "ONDC:TRV11" },
    { Id: 44, "Name": "ONDC:TRV12", "value": "ONDC:TRV12" },
    { Id: 45, "Name": "ONDC:TRV13", "value": "ONDC:TRV13" },
    { Id: 46, "Name": "ONDC:TRV14", "value": "ONDC:TRV14" }

  ]
  const Cities = [
    { Id: 1, "Name": "All", "value": "", "state": "", CreatedOnUtc: "" },
    { Id: 1, "Name": "Bangalore", "value": "std:080", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 2, "Name": "Chennai", "value": "std:044", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 3, "Name": "Coimbatore", "value": "std:0422", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 4, "Name": "Madurai", "value": "std:0452", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 5, "Name": "Salem", "value": "std:0427", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 6, "Name": "Tirupur", "value": "std:0421", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 7, "Name": "Erode", "value": "std:0424", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 8, "Name": "Trichy", "value": "std:0431", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 9, "Name": "Virudhunagar", "value": "std:04562", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 10, "Name": "Trichur", "value": "std:0487", "state": "Kerala", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
  ]
  return (
    <>
      <AccordionContainer
        child={
          <div className='flex flex-col'>
            <div className=' grid md:grid-cols-5 lg:grid-cols-5 gap-4'>

              <InputContainer
                label="Transaction Id"
                name="transaction_id"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'transaction_id',
                  )
                }}
                type="text"
                value={selectedGateway?.transaction_id}
              />
              <InputContainer
                label="Message Id"
                name="message_id"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'message_id',
                  )
                }}
                type="text"
                value={selectedGateway?.message_id}
              />

              <InputContainer
                label="Buyer App"
                name="bap_id"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'bap_id',
                  )
                }}
                type="text"
                value={selectedGateway?.bap_id}
              />
              <InputContainer
                label="Seller App"
                name="bpp_id"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'bpp_id',
                  )
                }}
                type="text"
                value={selectedGateway?.bpp_id}
              />

              <InputContainer
                label="Action"
                labelField="Name"
                list={actions}
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'action',
                  )
                }}
                type="select"
                valueField="value"
                value={selectedGateway?.action}
              />
              <InputContainer
                label="Domain Name"
                labelField="Name"
                list={domains}
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'domain',
                  )
                }}
                type="select"
                valueField="value"
                value={selectedGateway?.domain}
              />

              <InputContainer
                label="Cities"
                labelField="Name"
                list={Cities}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'city',
                  )
                }}
                type="select"
                valueField="value"
                value={selectedGateway?.city}
              />

              <InputContainer
                label="From"
                name="transaction_from"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'transaction_from'
                  )
                }}
                type="date"
                value={selectedGateway?.transaction_from}
              />

              <InputContainer
                label="To"
                name="transaction_to"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'transaction_to'
                  )
                }}
                type="date"
                value={selectedGateway?.transaction_to}
              />
            </div>
            <div className='flex flex-row justify-end items-end'>
              <button
                onClick={() => apply({
                  transaction_id: "",
                  message_id: "",
                  bpp_id: "",
                  bap_id: "",
                  action: "search",
                  domain: "",
                  city: '',
                  transaction_from: '',
                  transaction_to: '',
                })}
                type='button'
                className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 w-40 justify-start"
              >
                Reset
              </button>
              <button
                onClick={() => apply(selectedGateway)}
                type='button'
                className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 w-40 justify-start"
              >
                Search Logs
              </button>
            </div>
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Filters"
      />

    </>
  )
}